import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";

import Login from "../pages/Login";
import Main from "../pages/Main";
import Calendario from "../pages/Main/Calendario";
import Carga from "../pages/Main/Carga";
import Home from "../pages/Main/Home";
import Pedidos from "../pages/Main/Pedidos";
import NovoPedido from "../pages/Main/Pedidos/NovoPedido";
import CriarSimulacao from "../pages/Main/Simulacao/CriarSimulacao";
import DetalhesSimulacao from "../pages/Main/Simulacao/Detalhes";
import DetalhesPedidos from "../pages/Main/Pedidos/NovoPedido/DetalhesPedido";
import NovoPagamento from "../pages/Main/Pedidos/NovoPedido/DetalhesPedido/NovoPagamento";
import NovaCarga from "../pages/Main/Carga/NovaCarga";
import Configuracao from "../pages/Main/Configuracao";
import DetalhesCargas from "../pages/Main/Carga/DetalhesCargas";
import {
  ProtectedRoute,
  ProtectedRouteAdmin,
  ProtectedRouteNormalUser,
} from "../auth/PrivateRoutes/index";
import EditarPedido from "../pages/Main/Pedidos/EditarPedido";
import EditarPagamento from "../pages/Main/Pedidos/NovoPedido/DetalhesPedido/EditarPagamento";
import EditarCarga from "../pages/Main/Carga/EditarCarga";
import PrevisionsPage from "../pages/Main/Previsoes";
import EditPrevisionsPage from "../pages/Main/Previsoes/edit";
import ProductsPage from "../pages/Main/Produtos";

import ProductDetailsPage from "../pages/Main/Produtos/DetalhesProduto";
import CreateProductPage from "../pages/Main/Produtos/CriarProduto";
import EditProductPage from "../pages/Main/Produtos/EditarProduto";
import PaymentsPage from "../pages/Main/Pagamento";
import CreatePendingIssuePage from "../pages/Main/Carga/CriarPendencia";
import OrderLoadPendingIssuesPaegge from "../pages/Main/Carga/Pendencias";
import OrderLoadPendingIssuesPage from "../pages/Main/Carga/Pendencias";
import CreatePaymentMethodPage from "../pages/Main/MetodoPagamento/CriarMetodoPagamento";
import PaymentMethodPage from "../pages/Main/MetodoPagamento";
import CalculatorPage from "../pages/Main/Calculadora";
import SimulationsList from "../pages/Main/Simulacao";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      {/* Redirecionamento de '/' para '/login' se não autenticado */}
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Main />
          </ProtectedRoute>
        }
      >
        <Route
          path="/configuracoes"
          element={
            <ProtectedRouteAdmin requiredRole="ADMIN">
              <Configuracao />
            </ProtectedRouteAdmin>
          }
        />

        <Route
          path="/dashboard"
          element={
            <ProtectedRouteNormalUser requiredRole="USER">
              <Home />
            </ProtectedRouteNormalUser>
          }
        />
        <Route
          path="/calendario"
          element={
            <ProtectedRouteNormalUser requiredRole="USER">
              <Calendario />
            </ProtectedRouteNormalUser>
          }
        />
        <Route
          path="/pedidos"
          element={
            <ProtectedRouteNormalUser requiredRole="USER">
              <Pedidos />
            </ProtectedRouteNormalUser>
          }
        />
        <Route
          path="/pedidos/novo-pedido"
          element={
            <ProtectedRouteNormalUser requiredRole="USER">
              <NovoPedido />
            </ProtectedRouteNormalUser>
          }
        />
        <Route
          path="/pedidos/edit/:id"
          element={
            <ProtectedRouteNormalUser requiredRole="USER">
              <EditarPedido />
            </ProtectedRouteNormalUser>
          }
        />
        <Route
          path="/pedidos/detalhes/:id/:index"
          element={
            <ProtectedRouteNormalUser requiredRole="USER">
              <DetalhesPedidos />
            </ProtectedRouteNormalUser>
          }
        />
        <Route
          path="/pedidos/detalhes/:id/novo-pagamento"
          element={
            <ProtectedRouteNormalUser requiredRole="USER">
              <NovoPagamento />
            </ProtectedRouteNormalUser>
          }
        />
        <Route
          path="/pedidos/detalhes/:orderId/editar-pagamento/:id"
          element={
            <ProtectedRouteNormalUser requiredRole="USER">
              <EditarPagamento />
            </ProtectedRouteNormalUser>
          }
        />
        <Route
          path="/simulacoes"
          element={
            <ProtectedRouteNormalUser requiredRole="USER">
              <SimulationsList />
            </ProtectedRouteNormalUser>
          }
        />
        <Route
          path="/simulacoes/nova-simulacao"
          element={
            <ProtectedRouteNormalUser requiredRole="USER">
              <CriarSimulacao />
            </ProtectedRouteNormalUser>
          }
        />
        <Route
          path="/simulacao/:id"
          element={
            <ProtectedRouteNormalUser requiredRole="USER">
              <DetalhesSimulacao />
            </ProtectedRouteNormalUser>
          }
        />
        <Route
          path="/previsions"
          element={
            <ProtectedRouteNormalUser requiredRole="USER">
              <PrevisionsPage />
            </ProtectedRouteNormalUser>
          }
        />
        <Route
          path="/previsions/edit/:id"
          element={
            <ProtectedRouteAdmin requiredRole="ADMIN">
              <EditPrevisionsPage />
            </ProtectedRouteAdmin>
          }
        />
        <Route
          path="/produtos"
          element={
            <ProtectedRouteNormalUser requiredRole="USER">
              <ProductsPage />
            </ProtectedRouteNormalUser>
          }
        />
        <Route
          path="/produtos/criar"
          element={
            <ProtectedRouteAdmin requiredRole="ADMIN">
              <CreateProductPage />
            </ProtectedRouteAdmin>
          }
        />
        <Route
          path="/produtos/detalhes/:id"
          element={
            <ProtectedRouteNormalUser requiredRole="USER">
              <ProductDetailsPage />
            </ProtectedRouteNormalUser>
          }
        />
        <Route
          path="/produtos/editar/:id"
          element={
            <ProtectedRouteAdmin requiredRole="ADMIN">
              <EditProductPage />
            </ProtectedRouteAdmin>
          }
        />
        <Route
          path="/pagamentos"
          element={
            <ProtectedRouteNormalUser requiredRole="USER">
              <PaymentsPage />
            </ProtectedRouteNormalUser>
          }
        />

        <Route
          path="/cargas/nova-carga"
          element={
            <ProtectedRouteNormalUser requiredRole="USER">
              <NovaCarga />
            </ProtectedRouteNormalUser>
          }
        />
        <Route
          path="/cargas/edit/:id"
          element={
            <ProtectedRouteNormalUser requiredRole="USER">
              <EditarCarga />
            </ProtectedRouteNormalUser>
          }
        />
        <Route
          path="/criar-metodo-pagamento"
          element={
            <ProtectedRouteAdmin requiredRole="ADMIN">
              <CreatePaymentMethodPage />
            </ProtectedRouteAdmin>
          }
        />
        <Route
          path="/metodo-pagamento/:id"
          element={
            <ProtectedRouteNormalUser>
              <PaymentMethodPage />
            </ProtectedRouteNormalUser>
          }
        />

        <Route
          path="/calculadora"
          element={
            <ProtectedRouteNormalUser>
              <CalculatorPage />
            </ProtectedRouteNormalUser>
          }
        />
        <Route
          path="/cargas/:id/criar-pendencia"
          element={<CreatePendingIssuePage />}
        />
        <Route path="/cargas" element={<Carga />} />
        <Route
          path="/cargas/:id/detalhes/:index"
          element={<DetalhesCargas />}
        />
      </Route>
    </Routes>
  );
}
